export const INVALID_CHARS = 'invalid_chars';
export const TOO_LONG = 'too_long';
export const DUPLICATE = 'duplicate';
export const ONLY_WHITESPACES = 'only_whitespaces';